import {INavLink} from "../../@core/interfaces/nav-link.interface";
import {RoleEnum} from "../../@core/enums/role.enum";

export const CSGOFAST_LINKS: INavLink[] = [
  {
    label: 'Cases',
    link: 'cases',
    icon: 'package-open',
    roles: [RoleEnum.OWNER, RoleEnum.CASES_ADMIN, RoleEnum.CASES_MODERATOR]
  },
  {
    label: 'Battles',
    link: 'battles',
    icon: 'swords',
    roles: [RoleEnum.OWNER, RoleEnum.CASES_ADMIN, RoleEnum.CASES_MODERATOR]
  },
  {
    label: 'Categories',
    link: 'categories',
    icon: 'shapes',
    roles: [RoleEnum.OWNER, RoleEnum.CASES_ADMIN]
  },
  {
    label: 'Free cases',
    link: 'free-cases',
    icon: 'gift',
    roles: [RoleEnum.OWNER, RoleEnum.CASES_ADMIN]
  },
  {
    label: 'Leaders race',
    link: 'leaders-race',
    icon: 'trophy',
    roles: [RoleEnum.OWNER, RoleEnum.CASES_ADMIN]
  },
  {
    label: 'Raffle',
    link: 'raffles',
    icon: 'ticket',
    roles: [RoleEnum.OWNER, RoleEnum.RAFFLE_ADMIN, RoleEnum.RAFFLE_MODERATOR]
  },
  {
    label: 'Analytics',
    link: 'analytics',
    icon: 'chart-line',
    roles: [RoleEnum.OWNER, RoleEnum.RAFFLE_ADMIN, RoleEnum.RAFFLE_MODERATOR]
  },
  {
    label: 'Bonuses',
    link: 'bonuses',
    icon: 'piggy-bank',
    roles: [RoleEnum.OWNER, RoleEnum.CASES_ADMIN, RoleEnum.RAFFLE_ADMIN, RoleEnum.RAFFLE_MODERATOR]
  },
  {
    label: 'Bonus items',
    link: 'bonus-items',
    icon: 'piggy-bank',
    roles: [RoleEnum.OWNER, RoleEnum.CASES_ADMIN, RoleEnum.RAFFLE_ADMIN, RoleEnum.RAFFLE_MODERATOR]
  },
  {
    label: 'Solitaire',
    link: 'solitaire',
    icon: 'spade',
    roles: [RoleEnum.OWNER, RoleEnum.CASES_ADMIN, RoleEnum.CASES_MODERATOR, RoleEnum.SOLITAIRE_ADMIN, RoleEnum.SOLITAIRE_MODERATOR]
  }
];

export const HLTV_LINKS: INavLink[] = [
  {
    label: 'Cases',
    link: 'cases',
    icon: 'case',
    roles: [RoleEnum.OWNER, RoleEnum.CASES_ADMIN]
  },
  {
    label: 'Categories',
    link: 'categories',
    icon: 'category',
    roles: [RoleEnum.OWNER, RoleEnum.CASES_ADMIN]
  },
  {
    label: 'Free cases',
    link: 'free-cases',
    icon: 'free-case',
    roles: [RoleEnum.OWNER, RoleEnum.CASES_ADMIN]
  },
  {
    label: 'Upgrade',
    link: 'upgrade',
    icon: 'upgrade',
    roles: [RoleEnum.OWNER, RoleEnum.CASES_ADMIN]
  },
  {
    label: 'Samurai',
    link: 'samurai',
    icon: 'lol',
    roles: [RoleEnum.OWNER, RoleEnum.CASES_ADMIN]
  }
];
